// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResultRow-cls1_IEC","cls2":"AutoCompleteResultRow-cls2__Ff AutoCompleteResultRow-cls1_IEC"};